import React, { useEffect, useState } from "react";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import DropDownCustom from "../../Components/DropDownCustom/DropDownCustom";
import { getAllSubscriptionRequest } from "../../Actions/actions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Loader from "../../Components/Loader/Loader";
import { subscriptionColors } from "../../Reducers/reducers";

const statusColors = {
  "Demo Done": "bg-blue-200 text-blue-700",
  Contacted: "bg-yellow-200 text-yellow-700",
  Subscribed: "bg-purple-200 text-purple-700",
  "Not Contacted": "bg-red-200 text-red-700",
  "Demo Scheduled": "bg-green-200 text-green-700",
};



const SubscriptionRequest = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();

  const { loginData, loader } = useSelector((state) => state.userReducer);

  const [search, setSearch] = useState("");
  const [selectStatusFilter, setSelectStatusFilter] = useState("All");
  const [subscriptionRequest, setSubscriptionRequest] = useState([]);

  const filteredClients = subscriptionRequest.filter((client) => {
    return (
      client.name.toLowerCase().includes(search.toLowerCase()) &&
      (selectStatusFilter === "All" || client.status === selectStatusFilter)
    );
  });
  const statusFilterOptions = [
    { value: "All", label: "All" },
    { value: "Demo Done", label: "Demo Done" },
    { value: "Demo Scheduled", label: "Demo Scheduled" },
    { value: "Contacted", label: "Contacted" },
    { value: "Subscribed", label: "Subscribed" },
    { value: "Not Contacted", label: "Not Contacted" },
  ];

  useEffect(() => {
    dispatch(
      getAllSubscriptionRequest(loginData?.accessToken, (data) => {
        setSubscriptionRequest(data?.data);
      })
    );
  }, []);

  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };

  const selectedStatusFilterOption = statusFilterOptions?.find(
    (option) => option.value === selectStatusFilter
  );

  return (
    <ParentComponent>
      <PrimaryHeader />

      <div className="bg-white shadow-md rounded-lg">
        <div className="p-4 flex flex-col md:flex-row md:space-x-6 space-y-4 md:space-y-0">
          <div className="relative w-full">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border border-gray-300 rounded-lg pl-10 pr-4 py-2 w-full"
            />
          </div>
          <div className="w-full sm:w-full md:w-3/12">
            <DropDownCustom
              isClient={true}
              isAligned={true}
              selectedValue={selectedStatusFilterOption}
              handleChanges={(option) =>
                handleChanges(option, setSelectStatusFilter)
              }
              options={statusFilterOptions}
              isSearchable={false}
              label="Status Filter"
              placeholder="Select Status"
            />
          </div>
        </div>

        {loader ? (
          <div className="p-10">
            <Loader />
          </div>
        ) : (
          <div className="overflow-x-auto min-w-full">
            <table className="min-w-full text-left">
              <thead className="bg-[#361D3214]">
                <tr>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[100px]">
                    Name
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[120px]">
                    Company
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[120px]">
                    Company Email
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[160px] text-center ">
                    Package
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center ">
                    Phone Number
                  </th>
                  <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px] text-center">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredClients?.length > 0 ? (
                  filteredClients.map((client) => (
                    <tr
                      key={client.id}
                      className="border-b cursor-pointer"
                      onClick={() =>
                        navigation(`/subscription-requests/${client.name}`, {
                          state: { id: client.id },
                        })
                      }
                    >
                      <td className="py-4 px-4 font-normal text-gray-800 text-sm min-w-[100px]">
                        {client?.name}
                      </td>
                      <td className="py-4 px-4 text-gray-800 text-sm font-medium min-w-[120px]">
                        {client?.company}
                      </td>
                      <td className="py-4 px-4 text-gray-800 text-sm min-w-[120px]">
                        {client?.email}
                      </td>
                      <td className="py-4 min-w-[100px] text-center ">
                        <span
                          className={`px-3 py-1 rounded-md text-xs font-semibold self-center shadow-sm ${
                            subscriptionColors[client?.package]
                          }`}
                        >
                          {client?.package}
                        </span>
                      </td>
                      <td className="py-4 px-4 text-gray-800 text-sm min-w-[150px] text-center ">
                        {client?.phoneNumber}
                      </td>
                      <td className="py-4 px-4 min-w-[150px] text-center">
                        <span
                          className={`px-3 py-1 rounded-md font-semibold text-xs ${
                            statusColors[client?.status]
                          }`}
                        >
                          {client?.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center text-gray-500 py-4">
                      No subscription found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </ParentComponent>
  );
};

export default SubscriptionRequest;
